// reducers/favoriteReducers.js
import {
  FAVORITE_ADD_REQUEST,
  FAVORITE_ADD_SUCCESS,
  FAVORITE_ADD_FAIL,
  FAVORITE_REMOVE_REQUEST,
  FAVORITE_REMOVE_SUCCESS,
  FAVORITE_REMOVE_FAIL,
  FAVORITE_FETCH_REQUEST,
  FAVORITE_FETCH_SUCCESS,
  FAVORITE_FETCH_FAIL,
  FAVORITE_REMOVE_LOCAL,
  FAVORITE_OPTIMISTIC_TOGGLE,
} from '../constants/favoriteConstants';

export const favoriteReducer = (state = { favoris: [] }, action) => {
  switch (action.type) {

    case FAVORITE_ADD_REQUEST:
    case FAVORITE_REMOVE_REQUEST:
    case FAVORITE_FETCH_REQUEST:
      return { ...state, loading: true, error: undefined };

    case FAVORITE_REMOVE_LOCAL:
      return {
        ...state,
        favoris: state.favoris.filter(
          f => String(f.data?._id || f._id) !== String(action.payload)
        ),
        loading: false,
      };

    // 🚀 PERF : bascule optimiste — toggle local instantané (add/remove)
    case FAVORITE_OPTIMISTIC_TOGGLE: {
      const { id, type, data } = action.payload;
      const exists = state.favoris.some(
        f => String(f.data?._id || f._id) === String(id)
      );
      const favoris = exists
        ? state.favoris.filter(f => String(f.data?._id || f._id) !== String(id))
        : [...state.favoris, data ? { _id: id, type, data } : { _id: id, type }];
      return { ...state, favoris, loading: false };
    }

    case FAVORITE_ADD_SUCCESS:
    case FAVORITE_REMOVE_SUCCESS:
      // ⚠️ NE PLUS TOUCHER À favoris ICI
      return { ...state, loading: false };

    case FAVORITE_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        favoris: Array.isArray(action.payload) ? action.payload : [],
      };

    case FAVORITE_ADD_FAIL:
    case FAVORITE_REMOVE_FAIL:
    case FAVORITE_FETCH_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
